const LOGO_BLACK = "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/owco8ssq_intugle_logo_H_black_cropped.png";
const LOGO_WHITE = "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/jwc84o7e_intugle_logo_H_white_cropped.png";

const OPTIONS = [
  { key: "a", name: "Frosted Cream (current)", barClass: "bg-[#F7F5F0]/85 backdrop-blur-xl border-b border-[#3E2818]/10", light: false, linkClass: "text-[#3E2818]/75", btnClass: "bg-[#3E2818] text-[#F7F5F0]" },
  { key: "b", name: "Warm White", barClass: "bg-[#FCFAF6]/85 backdrop-blur-xl border-b border-[#3E2818]/10", light: false, linkClass: "text-[#3E2818]/75", btnClass: "bg-[#3E2818] text-[#F7F5F0]" },
  { key: "c", name: "Oat", barClass: "bg-[#EDE7DC]/90 backdrop-blur-xl border-b border-[#3E2818]/10", light: false, linkClass: "text-[#3E2818]/75", btnClass: "bg-[#3E2818] text-[#F7F5F0]" },
  { key: "d", name: "Espresso (solid)", barClass: "bg-[#211307] border-b border-white/10", light: true, linkClass: "text-[#F7F5F0]/70", btnClass: "bg-[#C2410C] text-[#F7F5F0]" },
  { key: "e", name: "Dark Roast Glass", barClass: "bg-[#211307]/70 backdrop-blur-xl border-b border-white/10", light: true, linkClass: "text-[#F7F5F0]/70", btnClass: "bg-[#C2410C] text-[#F7F5F0]" },
  { key: "f", name: "Cocoa", barClass: "bg-[#2B1E15] border-b border-white/10", light: true, linkClass: "text-[#F7F5F0]/70", btnClass: "bg-[#C2410C] text-[#F7F5F0]" },
];

const Bar = ({ o }) => (
  <div className="relative">
    {/* hero-like cream section behind */}
    <div className="bg-[#F7F5F0] pt-24 pb-16 px-8 relative overflow-hidden" style={{ minHeight: 220 }}>
      {/* the bar */}
      <div className={`absolute top-0 inset-x-0 z-[5] ${o.barClass}`}>
        <div className="max-w-7xl mx-auto px-8 flex items-center justify-between py-2.5">
          <img src={o.light ? LOGO_WHITE : LOGO_BLACK} alt="Intugle" className="h-14 w-auto" />
          <nav className="hidden md:flex items-center gap-9">
            <span className={`text-sm font-medium ${o.linkClass}`}>Platform</span>
          </nav>
          <button className={`rounded-full px-6 py-2.5 text-sm font-medium ${o.btnClass}`}>Get in Touch</button>
        </div>
      </div>
      {/* mock hero content */}
      <h1 className="font-display text-4xl font-medium tracking-tight text-[#3E2818] max-w-3xl">
        Transform How Business Gets Done with <span className="italic text-[#C2410C]">Agentic Applications</span>
      </h1>
      <p className="mt-3 text-[#6B5A4B] max-w-xl">Intugle helps organizations transform business processes with AI agents.</p>
    </div>
  </div>
);

export default function NavBgPreview() {
  return (
    <div className="min-h-screen bg-[#E7E1D6]">
      <div className="max-w-6xl mx-auto py-8 space-y-6 px-4">
        <h2 className="font-display text-2xl font-semibold text-[#3E2818]">Navbar Background — Options</h2>
        {OPTIONS.map((o) => (
          <div key={o.key}>
            <p className="mb-2 font-mono text-[11px] tracking-widest uppercase text-[#8C6A3F]">Option {o.key} — {o.name}</p>
            <div className="rounded-xl overflow-hidden shadow-sm border border-[#3E2818]/10">
              <Bar o={o} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
